export const validateContent = (content) => {
  const banned = ['best doctor', 'guaranteed', '100% cure', 'miracle', '#1 doctor', 'top doctor'];
  
  const lower = content.toLowerCase();
  for (let word of banned) {
    if (lower.includes(word)) {
      return {
        isValid: false,
        message: `⚠️ Contains banned phrase: "${word}"\nViolates Medical Council regulations!`
      };
    }
  }
  return { isValid: true };
};

export const addDisclaimer = (content) => {
  if (content.toLowerCase().includes('disclaimer')) return content;
  
  return content + '\n\n**Disclaimer**: This is for general awareness only and does not replace consultation with a qualified medical professional.';
};
